/*
  *调用方式：clientApi.func({key:value})
*/


import createNewTask from './request';

const API_TAG = {
    H5_MESSAGE: 'h5Message', // 发送数据给客户端
    GETCLIENTDATA: 'getClientData', // 异步获取客户端数据 （弃用）
    GETCLIENTDATASYNC: 'getClientDataSync', // 同步获取客户端数据
    PAYRESULT: 'payResult', // 通知客户端付钱结果（PC端）
    HTTPERROR:'errorOccuredInH5', // 通知客户端H5接口错误
    RECORD_TEST:'evaluate', // 发起语音评测
    HOMEWORK_PLAYBACK:'homeworkPlayback', // 播放语音评测录音
    CLOSE_PAGE:'closeH5Page', // 关闭H5页面
    RESTARTHOMEWORK:'restartHomework', // 重做作业
    COMPLETEHOMEWORK:'homeworkDone', // 作业完成
    EVENT_TRACKING:'eventTracking', // 事件埋点
    ALERT_VIEW:'alertView', //让客户端弹框
    ANCHOR_CLIENT:'anchorClient', // 通知客户端滑动到锚点
    APPLE_IAP:'appleIAP', // 通知ios调起内购
};

const clientApi = {
    h5Message: function(params) {
        return createNewTask(API_TAG.H5_MESSAGE, params);
    },
    getClientData: function(params) {
        return createNewTask(API_TAG.GETCLIENTDATA, params);
    },
    getClientDataSync: function(params) {
        return createNewTask(API_TAG.GETCLIENTDATASYNC, params);
    },
    payResult: function(params) {
        createNewTask(API_TAG.PAYRESULT, params);
    },
    httpError: function(params) {
        createNewTask(API_TAG.HTTPERROR, params);
    },
    recordTest: function(params) {
        createNewTask(API_TAG.RECORD_TEST, params);
    },
    homeworkPlayback: function(params) {
        createNewTask(API_TAG.HOMEWORK_PLAYBACK, params);
    },
    closeH5Page: function(params) {
        createNewTask(API_TAG.CLOSE_PAGE, params);
    },
    restartHomework: function(params) {
        createNewTask(API_TAG.RESTARTHOMEWORK, params);
    },
    completeHomework: function(params) {
        createNewTask(API_TAG.COMPLETEHOMEWORK, params);
    },
    eventTracking: function(params) {
        createNewTask(API_TAG.EVENT_TRACKING, params);
    },
    alertView: function(params) {
        createNewTask(API_TAG.ALERT_VIEW, params);
    },
    anchorClient: function(params) {
        createNewTask(API_TAG.ANCHOR_CLIENT, params);
    },
    appleIAP: function(params) {
        createNewTask(API_TAG.APPLE_IAP, params);
    }
};

export default clientApi;



// WEBPACK FOOTER //
// ./src/api/client.js